import { render } from "./NextStepsDisplay.vue?vue&type=template&id=135204e0&scoped=true"
import script from "./NextStepsDisplay.vue?vue&type=script&lang=js"
export * from "./NextStepsDisplay.vue?vue&type=script&lang=js"

import "./NextStepsDisplay.vue?vue&type=style&index=0&id=135204e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135204e0"]])

export default __exports__